<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-select
        placeholder="Viloyatlar"
        v-model="region_id"
        @change="getRegions"
        :loading="loading"
      >
        <el-option value="" label="Barchasi" />
        <el-option
          v-for="region in regions"
          :key="region.id"
          :value="region.id"
          :label="region.title"
        />
      </el-select>
      <el-select
        placeholder="Tuman/Shaxar"
        v-model="district_id"
        :loading="loading"
        @change="getDistricts"
      >
        <el-option value="" label="Barchasi" />

        <el-option
          v-for="district in districts"
          :key="district.id"
          :value="district.id"
          :label="district.title"
        />
      </el-select>
      <el-input
        v-model="search"
        style="width: 250px; margin-right: 10px"
        placeholder="Izlash"
        clearable
        @clear="onSearch"
      >
        <template #append>
          <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt="" />
          </el-button>
        </template>
      </el-input>
    </div>
    <el-table :data="users" border height="calc(100vh - 210px)">
      <el-table-column type="index" />
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="250" />
      <el-table-column
        prop="phone_number"
        label="Telefon raqami"
        min-width="150"
      />

      <el-table-column prop="is_verified" label="Verifikatsiya" min-width="150">
        <template #default="scope">
          <div
            v-if="scope.row.is_verified"
            style="display: flex; align-items: center; gap: 10px"
          >
            <p class="verified_user"></p>
            <p>O'tgan</p>
          </div>
          <div
            v-if="!scope.row.is_verified"
            style="display: flex; align-items: center; gap: 10px"
          >
            <p class="verified_user not_verified_user"></p>
            <p>O'tmagan</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pinfl" label="Pinfl" min-width="150">
        <template #default="scope">
          <div
            v-if="scope.row.pinfl"
            style="display: flex; align-items: center; gap: 10px"
          >
            <p class="verified_user"></p>
            <p>mavjud</p>
          </div>
          <div
            v-if="!scope.row.pinfl"
            style="display: flex; align-items: center; gap: 10px"
          >
            <p class="verified_user not_verified_user"></p>
            <p>mavjud emas</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="district_title"
        label="Tuman/Shahar"
        min-width="150"
      />
      <el-table-column width="200" label="Tahrirlash/O'chirish">
        <template #default="scope">
          <el-button
            size="small"
            @click="onEditUser(scope.row.id)"
            type="primary"
            >Tahrirlash</el-button
          >
          <el-button
            size="small"
            @click="onDeleteUser(scope.row.id)"
            type="danger"
            >O'chirish</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Moderatorlar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "UsersList",
  data() {
    return {
      loading: false,
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: null,
      districts: [],
      regions: [],
      region_id: null,
      district_id: null,
      users: [],
    };
  },
  methods: {
    getRegions() {
      this.$http
        .get(`api/v1/regions`)
        .then(({ data }) => {
          this.regions = data.regions;
          this.getDistricts();
          this.getUsersList();
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },
    getDistricts() {
      this.$http
        .get(`api/v1/districts`, {
          params: {
            region_id: this.region_id,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
          this.getUsersList();
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },

    onEditUser(id) {
      this.$router.push({ name: "UserForm", params: { id } });
    },
    onSearch() {
      this.currentPage = 1;
      this.$router.replace({ query: { ...this.$route.query, page: 1 } });
      this.getUsersList();
    },
    onDeleteUser(id) {
      ElMessageBox.confirm("Foydalanuvchini o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/users/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Foydalanuvchi o'chirildi",
              });
              this.getUsersList();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    getUsersList() {
      this.loading = true;
      this.$http
        .get("/api/v1/users", {
          params: {
            role: "user",
            search: this.search,
            limit: this.limit,
            region_id: this.region_id,
            district_id: this.district_id,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.users = data.users;
          this.totalCount = data.count;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.limit + 1;
    },
    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getUsersList();
    },
    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getUsersList();
    },
  },
  mounted() {
    this.getRegions();
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
};
</script>

<style scoped>
.verified_user {
  width: 20px;
  text-align: center;
  height: 20px;
  background: rgb(16, 191, 48);
  border-radius: 50%;
}

.not_verified_user {
  background: rgb(255, 76, 76);
}

.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
